const CDN = "https://customer-assets-rejwkqb3.emergentagent.net/job_03855948-9029-4da1-8bb9-5d670ca70d87/artifacts";

export const ASSETS = {
  logo: "/ct-blazers-logo.png",
  boysTeam: `${CDN}/xno9nt28_IMG_5870.webp`,
  girlsTeam: `${CDN}/1o5976c0_IMG_0403.JPEG`,
  clinicHuddle: `${CDN}/wxzzgl0g_IMG_1222.webp`,
  clinicGroup: `${CDN}/s5lu42tk_IMG_1233.JPEG`,
};

export const ORG = {
  name: "CT BLAZERS",
  location: "Norwalk, CT | Boys & Girls | 10U–17U",
  city: "Norwalk, CT",
  email: "Ctblazersbasketball@gmail.com",
  phone: "(203) 414-8688",
  tagline: "BUILD. COMPETE. DEVELOP.",
  subTagline: "The CT BLAZERS WAY",
};

export const SOCIALS = [
  { name: "Instagram", icon: "instagram", url: "https://www.instagram.com/ctblazers_24?utm_source=qr" },
  { name: "Facebook", icon: "facebook", url: "https://www.facebook.com/share/RmfMwfQbWQEDkvFW/?mibextid=hu50Ix" },
];

export const VALUES = [
  {
    title: "Player Development",
    desc: "Helping players improve their skills and understanding of the game.",
    icon: "trending-up",
  },
  {
    title: "Competition",
    desc: "Providing athletes with opportunities to compete and challenge themselves.",
    icon: "trophy",
  },
  {
    title: "Sportsmanship",
    desc: "Teaching players to respect the game, their teammates, coaches, opponents, and the community.",
    icon: "handshake",
  },
  {
    title: "THE BLAZER WAY",
    blazerWay: true,
    desc: "Creating a culture built around hard work, accountability, teamwork, and development.",
    icon: "flame",
  },
];

export const PROGRAMS = [
  {
    key: "aau",
    title: "AAU Teams",
    season: "Spring & Fall",
    desc: "Competitive AAU teams for boys and girls.",
    badge: "TRYOUT REQUIRED",
    cta: "LEARN ABOUT AAU",
    to: "/aau-tryouts",
    icon: "users",
    image: ASSETS.boysTeam,
  },
  {
    key: "clinics",
    title: "Summer Clinics",
    season: "All Skill Levels Welcome",
    desc: "Summer basketball clinics designed to help players develop their skills, confidence, and understanding of the game.",
    cta: "VIEW SUMMER CLINICS",
    to: "/summer-clinics",
    icon: "sun",
    image: ASSETS.clinicHuddle,
  },
  {
    key: "training",
    title: "Private & Small Group Training",
    season: "1-on-1 & Small Groups",
    desc: "CT BLAZERS coaches offer private and small-group basketball training.",
    cta: "FIND A COACH",
    to: "/private-training",
    icon: "target",
    image: ASSETS.clinicGroup,
  },
  {
    key: "3v3",
    title: "Winter 3v3 Development",
    season: "3rd Grade Development Program",
    desc: "A winter 3v3 development program designed specifically for 3rd grade players.",
    cta: "LEARN MORE",
    to: "/winter-3v3",
    icon: "snowflake",
    image: ASSETS.clinicHuddle,
  },
];

export const BIO_PLACEHOLDER =
  "Bio coming soon. Coaching background and player-development philosophy will be added here.";

export const STAFF = [
  { name: "Muni Gonzales", position: "President / Coach", training: true, photo: "/coaches/muni-gonzales.jpg", bio: "Coach Muni founded the CT BLAZERS program in 2019. The program started with one 4th grade team and has quickly turned into one of Fairfield County's premier programs! Coach Muni played high school basketball at Norwalk High School and competitive AAU throughout high school. With 8 years of youth basketball coaching experience, he has built a great reputation for teaching the game!" },
  { name: "TJ Rivera", position: "Director / Coach", training: true, photo: "/coaches/tj-rivera.jpg", bio: "With over 20 years of experience coaching and developing athletes, TJ Rivera has dedicated his career to helping boys and girls ages 4 and up grow both on and off the court. TJ began his coaching journey by running Norwalk's Biddy Basketball Program for eight years before expanding into FCBL and AAU basketball. He joined the CT BLAZERS program in 2019 as an assistant coach and has served as a head coach for the past three years. He also spent two years coaching both the JV and Varsity girls basketball teams at Wilton High School and has coached with WBA since 2019. In 2018, TJ founded his own basketball training business, #TJCARES, where he works with athletes ages 4 and up through individualized skill development and training. His passion is helping athletes build confidence, improve their fundamentals, and reach their full potential both as players and as people." },
  { name: "Kelly Gonzales", position: "Director", training: false, photo: "/coaches/kelly-gonzales.jpg", bio: "Kelly is the rock star behind the scenes! She truly keeps the machine running! She handles all scheduling, merchandise, team correspondence, uniforms and inquiries. She truly cares for each and every player that comes through our program!" },
  { name: "George Baez", position: "Coach", training: true, photo: "/coaches/george-baez.jpg", bio: "Coach George has over 30 years of playing, coaching, and training experience in the sport of basketball. He has experience at multiple levels — high school, college, and FIBA. Originally from the Bronx, NY, he finished high school in Connecticut. He played a year at Western Connecticut State University before pursuing a professional career overseas; that pursuit fell short due to injury. He joined the Marine Corps, where he served 12 years and continued his playing career, competing against college programs, semi-pro teams and G League teams. He has been coaching at the high school level the last 4 years and has been with the CT BLAZERS program the last 5 years. He coaches the middle school and high school divisions for the program." },
  { name: "Jose Torres", position: "Coach", training: true, photo: "/coaches/jose-torres.jpg", bio: "With 10+ years of coaching and player-development experience, Coach Jose has worked with athletes at every level, from youth players to college and professional athletes. A former player at Brien McMahon High School, he brings a player's perspective and a coach's passion to every training session. He has spent the past 7 years coaching at the high school level and currently serves as an assistant coach for the Weston High School boys basketball program. He has also been a dedicated coach with the CT BLAZERS AAU program for approximately 5 years. His coaching philosophy centers on building strong foundational skills, playing high-intensity defense, developing basketball IQ, and — most importantly — helping athletes build confidence, discipline, and character both on and off the court." },
  { name: "Austin Hall", position: "Coach", training: true, photo: "/coaches/austin-hall.jpg", bio: "Born and raised in Norwalk, Connecticut, Austin Hall has dedicated the past six years to coaching youth basketball, working with both boys and girls teams. He has experience coaching players at both the youth and high school levels. Throughout his coaching career, Austin has helped lead his teams to 16 championships. Austin's coaching philosophy centers around hard work, player development, teamwork, and having fun. He believes in creating an environment where athletes can grow both on and off the court while building confidence, discipline, and a true love for the game. He believes deeply in the quote, \"Hard work beats talent when talent fails to work hard.\"" },
  { name: "Mathew Omrao", position: "Coach", training: true, photo: "/coaches/matt-omrao.jpg", bio: "Coach Matt is our rising star! Coach Matt played basketball for 4 years at Norwalk High School and graduated in 2025. He is currently studying at the University of New Haven. Although new to the scene, Coach Matt already has experience under seasoned coaches! He's been an assistant for the Wilton Basketball Association as well as our CT BLAZERS program. His understanding of the game and patience to teach it is what makes him our rising star! Developing players on and off the court is his passion! Play hard, play smart, and trust your coach! Wise words from a young coach on the rise!" },
];

export const TRAINING_COACHES = STAFF.filter((s) => s.training).map((s) => s.name);

export const NAV_LINKS = [
  { label: "About", to: "/#about", type: "anchor" },
  { label: "Programs", to: "/#programs", type: "anchor" },
  { label: "Staff", to: "/#staff", type: "anchor" },
  { label: "AAU", to: "/aau-tryouts", type: "route" },
  { label: "Clinics", to: "/summer-clinics", type: "route" },
  { label: "3v3", to: "/winter-3v3", type: "route" },
  { label: "Training", to: "/private-training", type: "route" },
  { label: "Gallery", to: "/gallery", type: "route" },
  { label: "Merch", to: "/merch", type: "route" },
  { label: "Testimonials", to: "/testimonials", type: "route" },
];

export const GALLERY_CATEGORIES = ["Team Events", "Game Day", "Summer Clinics"];

// Add new categories to GALLERY_CATEGORIES for future seasons.
export const GALLERY = [
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/45u33ssb_IMG_5798.jpeg", category: "Team Events", alt: "CT Blazers coach working one-on-one with a young player on ball-handling" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/jl6fikme_IMG_3980.webp", category: "Team Events", alt: "CT Blazers team posing as Vertical Hoops Champions" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/ct9hcyht_IMG_4416.webp", category: "Team Events", alt: "CT Blazers team celebrating as Zero Gravity Champs" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/x4iupj5e_IMG_4516.webp", category: "Team Events", alt: "CT Blazers team photo with coaches at a tournament on Court #2" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/nuqfg8sz_IMG_1454.jpeg", category: "Team Events", alt: "CT Blazers coaches with a team jersey at a #TJCARES event" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/8y23fy0e_IMG_1453.jpeg", category: "Team Events", alt: "CT Blazers coaches with a young player" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/hk7bxfv3_IMG_3663.webp", category: "Team Events", alt: "CT Blazers championship team with trophy" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/q1ufds97_IMG_3622.png", category: "Game Day", alt: "Coach Muni in a game-day team huddle" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_develop-compete/artifacts/yrzdvudy_IMG_3533.webp", category: "Game Day", alt: "CT Blazers team huddle during a game timeout" },
  { src: ASSETS.boysTeam, category: "Team Events", alt: "CT Blazers boys team celebrating a championship" },
  { src: ASSETS.girlsTeam, category: "Team Events", alt: "CT Blazers girls team with championship rings" },
  { src: ASSETS.clinicGroup, category: "Summer Clinics", alt: "CT Blazers summer clinic group photo" },
  { src: ASSETS.clinicHuddle, category: "Summer Clinics", alt: "CT Blazers players in a team huddle at clinic" },
];

// Placeholder merch catalog (showcase only — no checkout yet).
// FUTURE PAYMENTS (Square, not yet built): one program set per season (Fall finalized, Spring TBD),
// admin-editable. Payments are one-time — a deposit followed by a remaining balance due by a set date.
// At checkout, collect the child's name and grade. Square payment links to be added later.
export const MERCH = [
  {
    name: "Flame Logo Hoodie",
    price: "$45",
    desc: "Cozy fleece pullover hoodie with the CT BLAZERS flame logo. Perfect for game days and chilly gyms.",
    image: "https://static.prod-images.emergentagent.com/jobs/03855948-9029-4da1-8bb9-5d670ca70d87/images/cdf7f6c87572282cb9ac3dca2ab55002b80354c4d30669de46c86e5b05f6e37f.jpeg",
  },
  {
    name: "Team Performance Tee",
    price: "$25",
    desc: "Lightweight, breathable performance tee in Blazers royal blue. Great for warmups and everyday wear.",
    image: "https://static.prod-images.emergentagent.com/jobs/03855948-9029-4da1-8bb9-5d670ca70d87/images/e2fa8afc8080a1599ab16903a6fed440a9a6b103e671376f762c8aced4bf7795.jpeg",
  },
  {
    name: "Snapback Hat",
    price: "$22",
    desc: "Adjustable flat-brim snapback with embroidered logo and orange accent stitching.",
    image: "https://static.prod-images.emergentagent.com/jobs/03855948-9029-4da1-8bb9-5d670ca70d87/images/468ec323c879a017008204bd948f947f335be9f984add91c7959bf38dc3ee38a.jpeg",
  },
  {
    name: "Game Shorts",
    price: "$28",
    desc: "Athletic mesh shorts with a royal blue side stripe — built for practice and play.",
    image: "https://static.prod-images.emergentagent.com/jobs/03855948-9029-4da1-8bb9-5d670ca70d87/images/746d77ac5babbc85cc85cc3fd02f2e43b9bc4950d3494a3f53a9e78483e92765.jpeg",
  },
  {
    name: "Shooting Long-Sleeve",
    price: "$35",
    desc: "Warm-up long-sleeve shooting shirt for pregame, training and cooler days.",
    image: "https://static.prod-images.emergentagent.com/jobs/03855948-9029-4da1-8bb9-5d670ca70d87/images/5061642fcdf477b199b8f9590666548a396b13ea40d803c50d7790c91aafb21f.jpeg",
  },
  {
    name: "Cinch Gym Bag",
    price: "$18",
    desc: "Durable drawstring cinch bag with orange cords for shoes, ball and gear.",
    image: "https://static.prod-images.emergentagent.com/jobs/03855948-9029-4da1-8bb9-5d670ca70d87/images/369f5a7d39bdd4f6c81484b3db9f00001b131cf76643c4a28225fd8a34e02a1c.jpeg",
  },
];
